// locationMarkerIcons — SVG-Marker-Icons für den Verortungs-Editor. Ersetzen die cyan Raster-PNGs
// (move.png / marker.png / post.png). Rollen:
//   center = Ursprungspunkt p0 (Ring mit DURCHSICHTIGER Mitte — man sieht die exakte Stelle durchs Loch)
//   point  = Richtungspunkt / „Fähnchen" (voller Punkt mit weißem Ring)
//   move   = Gruppen-Verschieber (weiße Scheibe + 4-Richtungs-Pfeil, bewusst anders als die Punkte)
// Farbe = das alte Locate-Cyan (#24F4FF, aus basic.js drawingOptions): leuchtet auf mehr Karten-Untergründen als der
// Archiv-Akzent. NUR die Punkt-Marker nutzen dieses Cyan; die Form (Linien + Fill der LocationShapeLayer) bleibt
// akzentfarben. Cyan-Dunkel via unsichtbarem Probe-Element aufgelöst (SVG kennt kein color-mix()).
// Rückgabe: google.maps-kompatible Icon-Objekte ({ url:data-URI, scaledSize, anchor }), Anker mittig.

// Basisfarbe der Verortungs-Marker: das Legacy-Locate-Cyan (basic.js drawingOptions strokeColor/fillColor #24F4FF).
const LOCATE_CYAN = '#24F4FF';

function resolveMarkerColors() {
    const probe = document.createElement('span');
    probe.style.cssText = 'position:absolute;visibility:hidden';
    document.body.appendChild(probe);
    const val = (expr) => { probe.style.color = expr; return getComputedStyle(probe).color; };
    const base = val(LOCATE_CYAN);
    const baseDark = val('color-mix(in srgb, ' + LOCATE_CYAN + ', black 25%)');
    probe.remove();
    return { base, baseDark };
}

function svgIcon(svg, size) {
    return {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
        scaledSize: new google.maps.Size(size, size),
        anchor: new google.maps.Point(size / 2, size / 2)   // mittig auf der Position
    };
}

export function createLocationMarkerIcons() {
    const { base, baseDark } = resolveMarkerColors();

    const centerSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">'
        + '<circle cx="12" cy="12" r="6" fill="none" stroke="#fff" stroke-width="5"/>'          // weißer Halo-Ring (Kontrast über Karte/Satellit)
        + '<circle cx="12" cy="12" r="6" fill="none" stroke="' + base + '" stroke-width="2.4"/>'  // Cyan-Ring, Mitte durchsichtig
        + '</svg>';

    const pointSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">'
        + '<circle cx="12" cy="12" r="6.5" fill="#fff"/>'                 // weißer Ring
        + '<circle cx="12" cy="12" r="4.6" fill="' + base + '"/>'         // voller Cyan-Punkt
        + '</svg>';

    const moveSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">'
        + '<circle cx="12" cy="12" r="10" fill="#fff" stroke="' + base + '" stroke-width="1.6"/>'
        + '<g fill="none" stroke="' + baseDark + '" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">'
        + '<path d="M12 6.4V17.6M6.4 12H17.6"/><path d="M12 5.2l2 2M12 5.2l-2 2"/>'
        + '<path d="M12 18.8l2-2M12 18.8l-2-2"/><path d="M5.2 12l2-2M5.2 12l2 2"/><path d="M18.8 12l-2-2M18.8 12l-2 2"/>'
        + '</g></svg>';

    return {
        center: svgIcon(centerSvg, 20),
        point: svgIcon(pointSvg, 18),
        move: svgIcon(moveSvg, 26)
    };
}
